module.exports = __webpack_public_path__ + "static/img/news1.bded4c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news4/news1.jpg
// module id = 8b8l
// module chunks = 1